import { Component, TemplateRef, ViewChild } from '@angular/core';
import { Action } from '@fullcalendar/core/internal';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { HorsPta } from 'src/app/shared/models/activite_hors';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { Constant } from 'src/app/shared/service/utils/contant';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-activite-hors-pta',
  templateUrl: './activite-hors-pta.component.html',
  styleUrl: './activite-hors-pta.component.scss'
})

export class ActiviteHorsPtaComponent {

  // breadcrumb items
  breadCrumbItems: Array<{}>;

  submitted: boolean;

  actionData: any = [];
  modalRef: NgbModalRef | null = null;

  itemToDelete!: Action;

  paginatedProjets = [];
  firstProjets: number = 0; // La page actuelle (commence à 0)
  rowsProjets: number = 10; // Nombre d'éléments par page
  totalRecords: number = 0; // Nombre total d'éléments
  isLoading: boolean = false;
  activiteHorsPtaItems: any = [];
  filteredData: any = [];
  searchTerm: any;
  @ViewChild('addmodalContent') modalContent!: TemplateRef<any>;
  @ViewChild('editmodalContent') modalContent1!: TemplateRef<any>;


  item: HorsPta = new HorsPta();
  editItem: HorsPta = new HorsPta();
  dateDebut: any;
  dateFin: any;
  serviceItems: any = [];
  selectedService: any;
  constructor(
    private modalService: NgbModal,
    private paramservice: ParameterService,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private ngxService: NgxUiLoaderService,
    private paramService: ParameterService,
  ) { }

  ngOnInit(): void {
    const exercice = this.localstorage.getExerciceToUserToSuivieEvaluation();

    this.dateDebut = `${exercice}-01-01`;
    this.dateFin = new Date().toISOString().split('T')[0];

    this.getService();
    this.getActiviteHorsPta();

  }




  getService() {

    this.paramService.fetchDataService().subscribe(
      (response: any) => {

        this.serviceItems = response.data;

      },
      (error: any) => {
        console.log("une erreur est survenu", error);

      }
    )
  }


  getActiviteHorsPta() {

    const requestData = {
      date_debut: this.dateDebut,
      date_fin: this.dateFin,
      service_id: this.selectedService,
      type_operation: 'data',

    }
    this.ngxService.start();
    this.paramservice.getActivitéHorsPta(requestData).subscribe(
      (response: any) => {
        this.activiteHorsPtaItems = response.data;
        ////console.log("this.actionData",this.actionData);

        this.ngxService.stop();

        this.updatePaginatedProjets();

      },
      (error) => {
        ////console.log("une erreur est survenu",error);
        this.ngxService.stop();

      }

    );
  }


  filterData() {
    const lowerSearchTerm = this.searchTerm.toLowerCase();

    if (!lowerSearchTerm) {
      this.filteredData = [...this.activiteHorsPtaItems]; // Réinitialiser avec toutes les données
    } else {
      this.activiteHorsPtaItems = this.activiteHorsPtaItems.filter((item: any) => {
        // Vérifier que les propriétés existent avant de filtrer
        const matchesLibelle = item.libelle && item.libelle.toLowerCase().includes(lowerSearchTerm);
        const matchesValeurReference = item.valeur_reference && item.valeur_reference.toLowerCase().includes(lowerSearchTerm);
        const matchesSourceVerification = item.source_verification && item.source_verification.toLowerCase().includes(lowerSearchTerm);
        const matchesUnite = item.unite && item.unite.toLowerCase().includes(lowerSearchTerm);
        const matchesModeCalcul = item.mode_calcul && item.mode_calcul.toLowerCase().includes(lowerSearchTerm);

        const projet = item.projet || {};
        const matchesProjetCode = projet.code && projet.code.toLowerCase().includes(lowerSearchTerm);
        const matchesProjetLibelle = projet.libelle && projet.libelle.toLowerCase().includes(lowerSearchTerm);

        const typeIndicateur = item.type_indicateur || {};
        const matchesTypeIndicateurLibelle = typeIndicateur.libelle && typeIndicateur.libelle.toLowerCase().includes(lowerSearchTerm);

        return matchesLibelle || matchesValeurReference || matchesSourceVerification ||
          matchesUnite || matchesModeCalcul || matchesProjetCode || matchesProjetLibelle ||
          matchesTypeIndicateurLibelle;
      });


      this.totalRecords = this.activiteHorsPtaItems.length;
      this.firstProjets = 0; // Reset to the first page
      this.updatePaginatedProjets();

    }


  }

  onPageChangeProjets(event: any) {
    this.firstProjets = event.first; // Mise à jour de la page actuelle
    this.rowsProjets = event.rows; // Mise à jour de la page actuelle
    this.updatePaginatedProjets();
  }

  // Méthode pour mettre à jour les données paginées des projets
  updatePaginatedProjets() {
    const start = this.firstProjets;
    const end = start + this.rowsProjets;
    this.paginatedProjets = this.activiteHorsPtaItems.slice(start, end);
  }



  openModal() {
    this.modalService.open(this.modalContent, {
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
  }


  editModal(item: any) {

    console.log("item", item);

    this.editItem = item;

    const dateValeur = item.date_realisation;
    if (dateValeur) {
      const date = new Date(dateValeur);

      console.log("dd");

      // Formater la date au format 'YYYY-MM-DD' pour l'input de type 'date'
      this.editItem.date_realisation = date.toISOString().split('T')[0];
    }
    this.modalService.open(this.modalContent1, {
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
  }

  confirmSuppression(event: any) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Êtes-vous sûr de vouloir supprimer?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Oui', // Définir le libellé du bouton "Oui"
      rejectLabel: 'Non', // Définir le libellé du bouton "Non"
      accept: () => {
        this.paramservice.deleteAHorsPta(event.reference).subscribe(
          (response: any) => {
            ////console.log("la reponse du webserice",response);
            this.getActiviteHorsPta();
            this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });

          },
          (error: any) => {
            this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: error.message });
            ////console.log("une erreur est survenu",error);
          },
        )
      },
    });
  }



  addHorsActivitePta() {
    if (!this.item.canSave()) {
      this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: this.item.getErrorMessage() });
    }

    this.item.annee = this.localstorage.getExerciceToUserToSuivieEvaluation();

    if (this.item.canSave()) {
      this.ngxService.start();

      console.log("this.item", this.item);


      this.paramService.addHorsActivitePta(this.item).subscribe(
        (response: any) => {
          this.getActiviteHorsPta();

          ////console.log("la reponse du webservice",response);
          this.modalService.dismissAll();
          this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
          this.ngxService.stop();
        },
        (error: any) => {
          ////console.log("une erreur est survenu",error);
          //  this.modalService.dismissAll();
          this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: "Une erreur est survenue. Veuillez réessaye" });
          this.ngxService.stop();
        }
      )
    }
  }//end addIndicateur

  updateHorsActivitePta() {
    // if (!this.editItem.canSave()) {
    //   this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: this.item.getErrorMessage() });
    // }
    //  if (this.item.canSave()) {

    this.editItem.annee = this.localstorage.getExerciceToUserToSuivieEvaluation();

    this.ngxService.start();
    this.paramService.updateHorsActivitePta(this.editItem.reference, this.editItem).subscribe(
      (response: any) => {
        ////console.log("la reponse du webservice",response);
        this.modalService.dismissAll();

        this.getActiviteHorsPta();

        this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
        this.ngxService.stop();
      },
      (error: any) => {
        ////console.log("une erreur est survenu",error);
        //  this.modalService.dismissAll();
        this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: "Une erreur est survenue. Veuillez réessaye" });
        this.ngxService.stop();
      }
    )
    //  }
  }//end addIndicateur



  exportToDocument(typeDoc: any) {
    //check
    if (this.dateDebut === null || this.dateDebut === undefined) {
      this.messageService.add({ severity: 'error', summary: 'TEP', detail: 'Veuillez renseigner la date de début', life: 3000 });
      return;
    }
    if (this.dateFin === null || this.dateFin === undefined) {
      this.messageService.add({ severity: 'error', summary: 'TEP', detail: 'Veuillez renseigner la date de fin', life: 3000 });
      return;
    }

    this.paramservice.printStatistiqueHorsPta().subscribe(
      (response: Blob) => {
        const filename = 'Statistiques_hors_pta.pdf';
        FileSaver.saveAs(response, filename);

        const url = URL.createObjectURL(response);
        window.open(url, '_blank');

        this.ngxService.stop();
        this.messageService.add({ severity: 'success', summary: 'Téléchargement', detail: 'Le fichier a été téléchargé avec succès', life: 3000 });
      },
          (error: any) => {
        this.ngxService.stop();

        if (error.error instanceof Blob) {

          const reader = new FileReader();

          reader.onload = () => {
            try {
              const err = JSON.parse(reader.result as string);

              this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: err.message || 'Téléchargement échoué'
              });

            } catch (e) {
              this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: 'Erreur lors du traitement du message'
              });
            }
          };

          reader.readAsText(error.error);

        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: error.error?.message || 'Téléchargement échoué'
          });
        }
      }
    );
  }//end export



  exportToDocumentHorsPta(typeDoc: any) {
    //check
    if (this.dateDebut === null || this.dateDebut === undefined) {
      this.messageService.add({ severity: 'error', summary: 'TEP', detail: 'Veuillez renseigner la date de début', life: 3000 });
      return;
    }
    if (this.dateFin === null || this.dateFin === undefined) {
      this.messageService.add({ severity: 'error', summary: 'TEP', detail: 'Veuillez renseigner la date de fin', life: 3000 });
      return;
    }

    const requestData = {
      date_debut: this.dateDebut,
      date_fin: this.dateFin,
      service_id: this.selectedService,
      type_operation: 'pdf',

    }
    this.paramservice.printStatistiqueHorsPtaH(requestData).subscribe(
      (response: Blob) => {
        const filename = 'Statistiques_hors_pta.pdf';
        FileSaver.saveAs(response, filename);

        const url = URL.createObjectURL(response);
        window.open(url, '_blank');

        this.ngxService.stop();
        this.messageService.add({ severity: 'success', summary: 'Téléchargement', detail: 'Le fichier a été téléchargé avec succès', life: 3000 });
      },
      (error) => {
        this.ngxService.stop();
        this.messageService.add({ severity: 'error', summary: 'Téléchargement', detail: error, life: 3000 });
      }
    );
  }//end export

}
